import React, { useEffect, useState } from "react";
import { PieChart } from "react-minimal-pie-chart";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { decryptToken } from "../utils/getToken";

const premiumColors = [
  "#4A90E2", "#50E3C2", "#B8E986", "#F5A623", "#D0021B", "#9013FE",
  "#417505", "#F8E71C", "#7ED321", "#8B572A", "#00BCD4", "#FF4081"
];

const getCategoryColors = () => {
  const stored = localStorage.getItem("expense_category_colors");
  return stored ? JSON.parse(stored) : {};
};

const saveCategoryColors = (map) => {
  localStorage.setItem("expense_category_colors", JSON.stringify(map));
};

const ExpenseDashboard = () => {
  const [chartData, setChartData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [categoryColors, setCategoryColors] = useState(getCategoryColors());
  const userData = getDecryptedUserFromCookie("gta_mainstateuser");
  const url = process.env.REACT_APP_LINK;
  const token = decryptToken("accessToken") || ""

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${url}/api/expenses/all/${userData.main_id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        const data = await res.json();

        const categoryTotals = {};
        let grandTotal = 0;

        data.forEach(item => {
          const category = item.category?.trim() || "Other";
          const amount = parseFloat(item.amount) || 0;
          categoryTotals[category] = (categoryTotals[category] || 0) + amount;
          grandTotal += amount;
        });

        const updatedColors = { ...categoryColors };
        let colorIndex = 0;

        Object.keys(categoryTotals).forEach(cat => {
          if (!updatedColors[cat]) {
            updatedColors[cat] = premiumColors[colorIndex % premiumColors.length];
            colorIndex++;
          }
        });

        saveCategoryColors(updatedColors);
        setCategoryColors(updatedColors);

        const formatted = Object.entries(categoryTotals).map(([title, value]) => ({
          title: `${title.slice(0, 10)} ₹${value.toLocaleString("en-IN")}`,
          value,
          color: updatedColors[title] || "#ccc"
        }));

        setChartData(formatted);
        setTotalAmount(grandTotal);
      } catch (err) {
        console.error("Error loading expense data", err);
      }
    };

    if (userData?.main_id) fetchData();
  }, []);

  return (
    <div className="my-8 rounded-lg shadow-md p-4">
      <h3 className="text-[18px] font-semibold text-gray-800 mb-2">Expense Distribution</h3>
      {chartData.length === 0 ? (
        <p className="text-sm text-gray-500">No expense data available.</p>
      ) : (
        <>
          <div className="relative w-full max-w-xs mx-auto aspect-square mb-6">
            <PieChart
              data={chartData}
              totalValue={totalAmount}
              startAngle={0}
              lengthAngle={360}
              lineWidth={40}
              paddingAngle={3}
              animate
              rounded
              style={{ height: "100%", width: "100%" }}
              label={() => ""}
            />
            <div className="absolute inset-0 flex items-center justify-center text-lg font-bold text-gray-800">
              ₹ {totalAmount.toLocaleString("en-IN")}
            </div>
          </div>

          <div className="space-y-2">
            {chartData.map((entry, idx) => (
              <div key={idx} className="flex items-center text-sm gap-2" title={entry.title}>
                <span
                  className="inline-block w-3 h-3 rounded-full"
                  style={{ backgroundColor: entry.color }}
                ></span>
                <span className="text-gray-700 truncate">{entry.title.split(" ₹")[0]}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ExpenseDashboard;
